export default [
  {
    path: '/users',
    name: 'users-list',
    component: () => import('@/views/users/rider/pages/UsersList.vue'),
    meta: {
      resource: 'users',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Users',
      allowedCountries: ['LY'],
    },
  },
  {
    path: '/get-otp',
    name: 'get-user-otp',
    component: () => import('@/views/users/rider/components/OTP/GetOTP.vue'),
    meta: {
      resource: 'get-otp-users',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Get OTP',

    },
  },
  {
    path: '/user-fines',
    name: 'list-user-fines',
    component: () => import('@/views/users/rider/pages/UserFineList.vue'),
    meta: {
      resource: 'fine-events',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Fines',

    },
  },
  {
    path: '/users/:id',
    name: 'user-details',
    component: () => import('@/views/users/rider/pages/UserDetails.vue'),
    meta: {
      resource: 'users',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'User Details',
      breadcrumb: [
        {
          text: 'Users',
          to: '/users',
        },
      ],
      allowedCountries: ['LY'],
    },
  },
  {
    path: '/users/roles/list',
    name: 'users-roles',
    component: () => import('@/views/users/roles/RolesList.vue'),
    meta: {
      resource: 'roles',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Roles',
    },
  },
  {
    path: '/users/roles/new',
    name: 'users-roles-new',
    component: () => import('@/views/users/roles/AddRole.vue'),
    meta: {
      resource: 'roles',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'New Role',
      breadcrumb: [
        {
          text: 'Roles',
          to: '/users/roles',
        },
      ],
    },
  },
  {
    path: '/users/admins/list',
    name: 'users-admins',
    component: () => import('@/views/users/admins/AdminsList.vue'),
    meta: {
      resource: 'roles',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Roles',
    },
  },
  {
    path: '/eta-logs',
    name: 'eta-logs',
    component: () => import('@/views/users/rider/pages/EtaLogsPage.vue'),
    meta: {
      resource: 'users',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'ETA Logs',
    },
  },
]
